module.exports = __webpack_public_path__ + "img/28-12_checho_ramirez.644d73ff.jpg";